const emptyValueFor = (f) => {
	if (f.type === "switch") return false;
	if (f.type === "select" && f.multiple) return [];
	return "";
};

export const toParams = (filtersArr) => {
	const filters = filtersArr.reduce((acc, f) => {
		acc[f.key] = f.value === undefined ? emptyValueFor(f) : f.value;
		return acc;
	}, {});

	return filters;
};
